import MEWPClass from './mew-provider-class';
import { OCTIUM } from '@/utils/networks/types';
class OneInch {
  constructor(web3, chain) {
    return new MEWPClass(
      MEWPClass.supportedDexes.ONE_INCH,
      web3,
      [OCTIUM.name],
      chain
    );
  }
}
export default OneInch;
